module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SignSearchView.js"));
	}, "SignSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SignSearchView!./src/pages/Promote/OfflineActivity/SignSearch/SignSearchView.js
// module id = 1158
// module chunks = 438